import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import { BimEmpty } from './BimEmpty';
import { useScript } from '@/shared/hooks';
const BimGis = ({ style, viewToken, modelPosition, mapConfig: propsMapConfig, }) => {
    const bimGisRef = useRef();
    useEffect(() => {
        const loaderConfig = new BimfaceSDKLoaderConfig();
        loaderConfig.viewToken = viewToken;
        BimfaceSDKLoader.load(loaderConfig, (viewMetaData) => {
            const webAppConfig = new Glodon.Bimface.Application.WebApplicationGISConfig();
            webAppConfig.domElement = document.getElementById('bimGisId');
            const app = new Glodon.Bimface.Application.WebApplicationGIS(webAppConfig);
            bimGisRef.current = app.getViewer();
            bimGisRef.current.addScene(viewToken);
            // bimGisRef.current?.addEventListener(
            //   Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded,
            //   () => {
            //     const mapConfig = new Glodon.Bimface.Plugins.TileMap.MapConfig();
            //     mapConfig.viewer = bimGisRef.current;
            //     mapConfig.modelPosition = modelPosition;
            //     mapConfig.modelRotationZ = (0 * Math.PI) / 180;
            //     mapConfig.modelAltitude = 3.0;
            //     const map = new Glodon.Bimface.Plugins.TileMap.Map(mapConfig);
            //     map.setMapSource({
            //       url: 'http://t0.tianditu.gov.cn/img_w/wmts?tk=0b1abbca4b48c5c04d2bbab0bb265e0e',
            //       provider: 'Tianditu',
            //       credit: Glodon.Bimface.Common.Credit.Tianditu,
            //       ...propsMapConfig,
            //     });
            //     bimGisRef.current?.render();
            //   },
            // );
        }, (e) => {
            console.log('failure_load:', e);
        });
        return () => {
            if (bimGisRef.current) {
                bimGisRef.current?.destroy();
            }
        };
    }, [modelPosition, propsMapConfig, viewToken]);
    return _jsx("div", { id: "bimGisId", style: style });
};
export const BimfaceGis = (props) => {
    const status = useScript('https://static.bimface.com/api/BimfaceSDKLoader/BimfaceSDKLoader@latest-release.js');
    return useMemo(() => {
        return _jsx(_Fragment, { children: status === 'ready' ? _jsx(BimGis, { ...props }) : BimEmpty });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.viewToken, status]);
};
